import ko from 'knockout'
import { transpose, multiply, matrix } from 'mathjs'
import globals from './globals'
import species from './species'
import gear from './gear'
import charter from './charter'


function divit(array1, array2) {
    var result = [];
    var arrayLength = array1.length;
    for (var i = 0; i < arrayLength; i++) {
        if (array2[i] !== 0) {
            result.push(array1[i] / array2[i]);
        }
        else {
            result.push(0);
        }
    }
    return result;
}


//Uses JQuery
function deep_apply_deflator(deflator, apply_to) {
    var def = Number(deflator);
    if (ko.isObservable(apply_to)) {
	if (!isNaN(apply_to())) {
	    apply_to(apply_to()*deflator);
	}
    }

    //Needs explanation
    for (var prop in apply_to) {
        //This $.type function is deprecated, here is a possible solution: typeof
        //if ($.type(apply_to[prop]) === 'object') {
        if (!ko.isObservable(apply_to[prop])) {
            deep_apply_deflator(deflator, apply_to[prop]);
            continue;
	}
	try {
	    if (ko.isObservable(apply_to[prop])) {   
		if (!isNaN(apply_to[prop]())) {
		    apply_to[prop](apply_to[prop]()*def);
		}}
	}
	catch(err) {
	}
    }
}

function div(numerator, denominator) {
    return numerator/denominator;
}

function mult(a, b) {
    return a*b;
}

function pct(a, b) {
    return 100*a/b;
}


function init(a, b) {
    return 0;
}

function deep_apply(objectA, objectB, apply_to, fnc) {
    for (var prop in objectB) {
        var propVal = objectA[prop];
        var val = propVal;             
        var BPropVal = objectB[prop];
        var BVal = BPropVal; 

        if (typeof val === 'object' && val !== null) {
            if (!(prop in apply_to)) {
                apply_to[prop]={};
            } 
            deep_apply(val, BVal, apply_to[prop], fnc);
            continue;
        }

        try {
            if (ko.isObservable(val)) {
                if (!isNaN(val())) {
                    if (!ko.isObservable(apply_to[prop])){
                        apply_to[prop] = ko.observable(0);
                    }
                    var ret = fnc(val(),BVal());
                    ret = isNaN(ret) ? 0 : ret;
                    apply_to[prop](ret);
                }
            }
        }
        catch(err) {
            console.log(err.message);
        }
    }
}

ko.extenders.numeric = function (target, options) {
    target.hasError = ko.observable();
    
    function validate(newValue) {
	target.hasError(isNaN(newValue)||(newValue==="") ? true : false);
    }

    validate(target());
    target.subscribe(validate);
    return target;
};

ko.extenders.numericGTZero = function (target, options) {
    target.hasError = ko.observable();
    function validate(newValue) {
	target.hasError(isNaN(newValue)||(newValue==="")||!(Number(newValue) > 0));
    }

    validate(target());
    target.subscribe(validate);
    return target;
};

ko.bindingHandlers.numericText = {
    update: function(element, valueAccessor, allBindingsAccessor) {
	var value = ko.utils.unwrapObservable(valueAccessor()),
            precision = ko.utils.unwrapObservable(allBindingsAccessor().precision);
	if (typeof precision === 'undefined') {
	    precision = ko.bindingHandlers.numericText.defaultPrecision;}
	    if (value) {
            var formattedValue = value.toFixed(precision);
            var parts = formattedValue.toString().split(".");
	        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            formattedValue = parts.join(".");
        } else {
            switch(precision) {
                case 0:
                    formattedValue = "0";
                    break;
                case 1:
                    formattedValue = "0.0";
                    break;
                default:
                    formattedValue = "0.00";
              }
        }
	
        ko.bindingHandlers.text.update(element, function() { return formattedValue; });
    },
    defaultPrecision: 10
};





function getIndSectors(mrsam) {
    var sectors = [...mrsam.sectors];
    sectors = sectors.concat(mrsam.va_sectors);
    sectors = sectors.concat(mrsam.hi_sectors);
    sectors = sectors.concat(mrsam.gov_sectors);
    sectors = sectors.concat(mrsam.a1_sectors);
    return sectors;
}

function getEmpSectors(mrsam) {
    var sectors = [...mrsam.sectors];
    sectors = sectors.concat(mrsam.a1_sectors);
    return sectors;
}

function prepBase(mrsam) {

    var sectors = getIndSectors(mrsam);

    var report = {};
    report.ind = {};
    report.emp = {};

    mrsam.regions.forEach(element => {
        report.ind[element] = {};       
        report.emp[element] = {};
    });

    mrsam.regions.forEach(function (r_value, r_i) {
        sectors.forEach(function (s_value, s_i) {
            report.ind[r_value][s_value] = ko.observable(0);
        });
    });
    // Now we need to load the employment data. 
    // It will go into the object at report.emp.[region][sector]
    // Emp only has sectors and a1_sectors


    sectors = getEmpSectors(mrsam);

    mrsam.regions.forEach(function (r_value, r_i) {
        sectors.forEach(function (s_value, s_i) {
            report.emp[r_value][s_value] = ko.observable(0);
        });
    });
    return report;
}

function loadBase(mrsam, report) {

    // Start with Industry. These are not merged in the code
    // so that Frank can iterate over the different reports.
    // Of course the data could be merged if desired.
    var sectors = getIndSectors(mrsam);

    var base_data = [...mrsam.base_ind];
    base_data = base_data.concat(mrsam.base_va);
    base_data = base_data.concat(mrsam.base_hi);
    base_data = base_data.concat(mrsam.base_sl);
    base_data = base_data.concat(mrsam.base_a1_ind);

    mrsam.regions.forEach(function (r_value, r_i) {
        sectors.forEach(function (s_value, s_i) {
            report.ind[r_value][s_value](base_data[s_i][r_i]);
        });
    });
    // Now we need to load the employment data. 
    // It will go into the object at report.emp.[region][sector]
    // Emp only has sectors and a1_sectors


    sectors = getEmpSectors(mrsam);

    base_data = [...mrsam.base_emp];
    base_data = base_data.concat(mrsam.base_a1_emp);

    mrsam.regions.forEach(function (r_value, r_i) {
        sectors.forEach(function (s_value, s_i) {
            report.emp[r_value][s_value](base_data[s_i][r_i]);
        });
    });
}


function initScenarios(model){
    if (localStorage.getItem(model) === null) {
        let scenariosArray = [];
        localStorage.setItem(model, JSON.stringify(scenariosArray))
    }
}


function checkScenario(name, model){
    var scenarioArray = JSON.parse(localStorage.getItem(model));
    return scenarioArray.filter(s => s.name === name).length === 0
}

function loadScenario(name, model) {

    var scenarioArray = JSON.parse(localStorage.getItem(model));
    var scenarioObj = scenarioArray.filter(s => s.name === name)[0]

    var mrsam;
    var vm;
    switch (model) {
    case "Species":
    mrsam = species;
    vm = Window.vms;
    break;
    case "Gear":
    mrsam = gear;
    vm = Window.vmg;
    break;
    case "Charter":
    mrsam = charter;
    vm = Window.vmc;
    break;
    }
    
    if (scenarioObj.deflator) {
        vm.selectedDeflator(scenarioObj.deflator);
    }
    vm.customDeflator(scenarioObj.customDeflator);

    mrsam.iv_disp2.forEach(element => {
        vm.mrsam_shock_vec[element.region][element.sector](scenarioObj.vectors.shift());
    });
   }
    
   function saveScenario(scenarioName, model) {
       
    var mrsam;
    var vm;

    var mrsamType = model;
    switch (mrsamType) {
    case "Species":
    mrsam = species;
    vm = Window.vms;
    break;
    case "Gear":
    mrsam = gear;
    vm = Window.vmg;
    break;
    case "Charter":
    mrsam = charter;
    vm = Window.vmc;
    break;
    }
    
    var sv = [];
    
    mrsam.iv_disp2.forEach(element => {
        sv.push(vm.mrsam_shock_vec[element.region][element.sector]());
    });
    
    var scenarioObj = {};
    scenarioObj.name = scenarioName;
    scenarioObj.vectors = sv;
    scenarioObj.deflator = vm.selectedDeflator();
    scenarioObj.customDeflator = vm.customDeflator();
    
    if (!checkScenario(scenarioName, model)) {
        removeScenario(scenarioName, model)
    }

    var scenarios = JSON.parse(localStorage.getItem(model))
    scenarios.push(scenarioObj)

    localStorage.setItem(model, JSON.stringify(scenarios));

    }
    

   function listScenarios(model) {

    var scenarios = JSON.parse(localStorage.getItem(model))
    var scenarioList = []

    for (let i = 0; i < scenarios.length; i++) {
        scenarioList.push(scenarios[i].name)
    }

    return scenarioList

   }
    
   function removeScenario(scenarioName, model) {
       
    var scenarioArray = JSON.parse(localStorage.getItem(model));
    var scenariosUpdated = scenarioArray.filter(s => s.name !== scenarioName)
    localStorage.setItem(model, JSON.stringify(scenariosUpdated));

   }
    
   if (typeof window !== "undefined"){
    Window.initScenarios = initScenarios;
    Window.checkScenario = checkScenario;
    Window.saveScenario = saveScenario;
    Window.loadScenario = loadScenario;
    Window.listScenarios = listScenarios;
    Window.removeScenario = removeScenario;
   }


export default function ViewModel(model) {



    var self = this;
    var mrsam;

    switch (model) {
        case "Species":
            mrsam = species
            break;
        case "Gear":
            mrsam = gear
            break;
        case "Charter":
            mrsam = charter
            break;
        default:
            mrsam = species
            break;
    }

    self.reports = mrsam.reports
    

    //deflator support
    self.selectedDeflator = ko.observable("2014");
    self.customDeflator = ko.observable().extend({ numericGTZero: true});
            
    self.finalDeflator = ko.computed(function () {
        var deflator;                
        if (self.selectedDeflator().deflator !== 0) {
            self.customDeflator(self.selectedDeflator().deflator);
            deflator = self.selectedDeflator().deflator;
        }
        else if (!self.deflatorError()) {
            deflator = self.customDeflator();
        }
        
        return deflator;
    });
            
    self.isSelected = ko.observable(false);
    self.setIsSelected = ko.computed(function() {
        if (self.selectedDeflator().deflator === 0) {
            self.customDeflator(1);
        }        
    });
            
            self.selectedRegion = ko.observable('All Regions');
            self.iv_disp = ko.computed(function() {
                if (self.selectedRegion().length == 0) {
                return mrsam.iv_disp2;
                }
                else {
                /*Some spaghetti. The rules for what to show on filtering are a bit complex:
                1) Always show RAK, WOK, and RUS. 
                2) If trawl, hook and line, groundfish pot, crab, salmon gillnet then show SHOREPROC-A for each region
                3) If CPH, add CPP
                4) If CV, add MS.
                The odd stuff at the end in the return preserves the order of the shock vector by returning a filtered iv_disp2.
                
                var filtReg = mrsam.iv_disp2.filter(anInput => (anInput.region === self.selectedRegion() && !['RAK','WOC','RUS'].includes(anInput.region)));
                var filtSec = mrsam.iv_disp2.filter(anInput => (anInput.sector.indexOf(self.selectedRegion()) > -1 && !['RAK','WOC','RUS'].includes(anInput.region)));
                var rakwocrus = mrsam.iv_disp2.filter(anInput => (['RAK','WOC','RUS'].includes(anInput.region)));
                var extraShore = [];
                filtSec.forEach(element => 
                {
                if(['Trawl-A','Hook and Line-A','Groundfish Pot-A','Salmon gillnet-A','Other Gear-A','Crab-A'].includes(element.sector)) {
                extraShore.push({region:element.region, sector:'SHOREPROC-A'});
                }
                if(['CPH-A'].includes(element.sector)) {
                extraShore.push({region:element.region, sector:'CPP-A'});
                }
                if(['CVs-A'].includes(element.sector)) {
                extraShore.push({region:element.region, sector:'MS-A'});
                }
                });
                */
                var filtArray = [];
                var selectedReg = []

                selectedReg = selectedReg.concat(self.selectedRegion());

                selectedReg.forEach(element => 
                { 
                filtArray = filtArray.concat(mrsam.iv_disp2.filter(anInput => (anInput.region === element.name || anInput.sector.indexOf(element.name) > -1 )));
                });
                // var filts = filtReg.concat(filtSec).concat(extraShore).concat(rakwocrus);
                // return mrsam.iv_disp2.filter(element => (filts.find(el2 => el2.region===element.region && el2.sector===element.sector)));
                return mrsam.iv_disp2.filter(element => (filtArray.find(el2 => el2.region===element.region && el2.sector===element.sector)));
                }
                })

            self.regionsFlt = globals.regionsFlt;
        
            self.empPrec = function(precision, leg, table) {
                var prec = 2;
                if (leg==="emp" && table !== "table_c") {
                    prec = 0;}
                if (table === "table_c") {
                    prec = 1;}
                    
                if (precision) {
                    prec = 10;
                }
                return prec;
            }

            self.clearInputs = function() {
                mrsam.iv_disp2.forEach(element => {
                    self.mrsam_shock_vec[element.region][element.sector](0);
                })
            };

            self.reportNames = ko.observableArray(mrsam.reportNames);
    
            self.sectors = ko.observableArray(mrsam.sectors);
            self.regions = ko.observableArray(mrsam.regions);
            self.va_sectors = ko.observableArray(globals.va_sectors);
            self.a1_sectors = ko.observableArray(globals.a1_sectors);
            self.hi_sectors = ko.observableArray(globals.hi_sectors);
            self.gov_sectors = ko.observableArray(globals.gov_sectors);
            self.table_a = prepBase(mrsam);
            self.table_b = {};
            deep_apply(self.table_a, self.table_a, self.table_b, init);
            self.table_c = prepBase(mrsam);
    
            /*Prep the vector object*/
            self.mrsam_shock_vec = {};
            //self.table_b = {};
            //self.table_b.ind = {};
            //self.table_b.emp = {};
            
            mrsam.prep_shock(self.mrsam_shock_vec, self.table_b, mrsam);
    
            mrsam.regions.forEach(region => {
                for (var tot_element in mrsam.totals) {
                    var tot_sum_ind = 0.0;
                    var tot_sum_emp = 0.0;
                    mrsam.totals[tot_element].forEach(element => {
                        if (ko.isObservable(self.table_b.ind[region][element]))
                        {tot_sum_ind += self.table_b.ind[region][element]();}
                        if(self.table_b.emp[region]){
                        if (ko.isObservable(self.table_b.emp[region][element]))
                        {tot_sum_emp += self.table_b.emp[region][element]();}}            
                    })
                    self.table_b.ind[region][tot_element] = ko.observable(tot_sum_ind);
                    if(self.table_b.emp[region]){
                    self.table_b.emp[region][tot_element] = ko.observable(tot_sum_emp);}
                }
            });
    
            self.apply_changes = ko.computed( function() {
    
                loadBase(mrsam, self.table_a);

                var finalDeflator = self.finalDeflator();
    
                mrsam.map_shock_vector(self.mrsam_shock_vec); //Support Charter shock vector

                var lval;
                var mrsam_shock = [];
                mrsam.vec.forEach(element => {
                    lval = Number(self.mrsam_shock_vec[element.split(".")[0]][element.split('.')[1]]());
                    mrsam_shock.push(lval);
                });
    
                var adj_mrsam_shock = transpose(divit(mrsam_shock, mrsam.adjust));
                var mrsam_res = multiply(matrix(mrsam.matrix), adj_mrsam_shock);
            
                mrsam.vec.forEach(function (value, i) {
                    self.table_b.ind[value.split(".")[0]][value.split('.')[1]](mrsam_res._data[i]);
                });
    
                deep_apply_deflator(finalDeflator, self.table_a.ind);
            
                var emp_ratio = {};
                deep_apply(self.table_a.emp, self.table_a.ind, emp_ratio, div);
                deep_apply(emp_ratio, self.table_b.ind, self.table_b.emp, mult);
            
                mrsam.regions.forEach(region => {
                    for (var tot_element in mrsam.totals) {
                        var tot_sum_ind = 0.0;
                        var tot_sum_emp = 0.0;
                        mrsam.totals[tot_element].forEach(element => {
                            if (ko.isObservable(self.table_b.ind[region][element]))
                            {tot_sum_ind += self.table_b.ind[region][element]();}
                            if(self.table_b.emp[region]){
                            if (ko.isObservable(self.table_b.emp[region][element]))
                            {tot_sum_emp += self.table_b.emp[region][element]();} }           
                        })
                        self.table_b.ind[region][tot_element](tot_sum_ind);
                        if(self.table_b.emp[region]){
                            if (ko.isObservable(self.table_b.emp[region][tot_element]))
                        {self.table_b.emp[region][tot_element](tot_sum_emp);}}
                    }
                    
                    })
                    
                    self.table_b.ind = self.table_b.ind;
                    
                    deep_apply(self.table_b, self.table_a, self.table_c, pct); 
            });
        
            self.ShockVectorApplied = ko.computed(function () {
                self.apply_changes();
                });
            
            self.deflatorError = ko.computed(function () {
                return (self.customDeflator.hasError());
            });

}